/* =====================================================================
   PENDELLE — JS de la zone PAGES (agent PAGES). Chargé en defer après pendelle.js (window.PD).
   - PD.quiz(el)   outil « Trouvez votre luminaire » (calcul de la maquette, vrais produits)
                   initialisé sur tout [data-quiz] vide ; données : <script data-pd-finder-data> de la page,
                   sinon chargées via /?section_id=pd-finder-data ; paramètres d'URL si [data-params] :
                   ?piece=salon&surface=18&hauteur=std&style=japandi → ouvre directement le résultat.
   - Suivi de commande, recherche de la page 404, article (sommaire, lettrine, encadrés, tableaux,
     « modèles cités »), page panier (mise à jour Ajax), messages de formulaires.
   ===================================================================== */
(function () {
  'use strict';
  var PD = window.PD = window.PD || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) { return PD.money ? PD.money(c) : (Math.round(c) / 100).toFixed(2).replace('.', ',') + ' €'; }
  function nb(r) { if (PD.nb) PD.nb(r); }
  function ico(id, cls) { return '<svg class="ico' + (cls ? ' ' + cls : '') + '" aria-hidden="true" focusable="false"><use href="#' + id + '"/></svg>'; }
  function lines(arr) {
    return (arr || []).map(function (l) { return String(l).split('|').map(function (x) { return x.trim(); }); })
      .filter(function (p) { return p[0]; });
  }

  /* ------------------------------------------------------------ outil « Trouvez votre luminaire » */
  var DEF = {
    rooms: [['salon', 'Salon', 'sofa', 'salon', 'un salon'], ['salle-a-manger', 'Salle à manger', 'table', 'salle-a-manger', 'une salle à manger'], ['chambre', 'Chambre', 'bed', 'chambre', 'une chambre'], ['cuisine', 'Cuisine', 'pot', 'cuisine', 'une cuisine'], ['entree', 'Entrée, couloir', 'door', 'entree-et-couloir', 'une entrée'], ['bureau', 'Bureau', 'desk', 'bureau', 'un bureau']],
    heights: [['bas', 'Moins de 2,40 m', 'Plafond bas', 'un plafonnier, ou une suspension remontée au plus près du plafond'], ['std', '2,40 à 2,70 m', 'Le plus courant', 'le bas du luminaire à au moins 2,10 m du sol', 'suspendu à 75 cm environ au-dessus de la table'], ['haut', '2,70 à 3 m', 'Belle hauteur', 'que vous pouvez descendre davantage, en gardant 2,10 m de passage'], ['tres', 'Plus de 3 m', 'Volume, mezzanine', 'généreux, ou deux suspensions à des hauteurs différentes']],
    styles: [['wabi-sabi', 'Wabi-sabi', 'Matières brutes'], ['japandi', 'Japandi', 'Bois clair, lignes douces'], ['contemporain', 'Contemporain', 'Verre, métal, épure'], ['industriel', 'Industriel', 'Métal noir, verre ambré'], ['classique', 'Classique', 'Laiton, opalin'], ['tous', 'Peu importe', 'Montrez-moi tout']],
    t: {
      prog: 'Pièce, Surface, Hauteur, Style, Résultat',
      q1: 'Quelle pièce <em>éclairer</em> ?', h1: 'Choisissez la pièce : nous adaptons la forme et la hauteur.',
      q2: 'Quelle <em>surface</em> ?', h2: 'Faites glisser pour indiquer la surface de la pièce, environ.',
      q3: 'Quelle <em>hauteur</em> sous plafond ?', h3: 'Elle décide entre lustre, suspension et plafonnier.',
      q4: 'Quel <em>style</em> chez vous ?', h4: 'Un seul choix : nous gardons les modèles qui s\'y accordent.',
      see: 'Voir la sélection',
      empty: 'Aucun modèle ne correspond pour le moment. Voyez tous nos luminaires, ou écrivez-nous les dimensions de votre pièce.'
    },
    collUrl: ROOT + 'collections', allUrl: ROOT + 'collections/all'
  };
  var TABLE_ROOMS = ['salle-a-manger', 'cuisine'];
  var dataP = null;
  function loadData() {
    if (dataP) return dataP;
    var s = $('script[data-pd-finder-data]');
    if (s) { try { dataP = Promise.resolve(JSON.parse(s.textContent)); return dataP; } catch (e) {} }
    dataP = fetch(ROOT + '?section_id=pd-finder-data', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var x = $('script[data-pd-finder-data]', d);
        return x ? JSON.parse(x.textContent) : [];
      }).catch(function () { dataP = null; return []; });
    return dataP;
  }
  function diamRange(S) { var D = 16 * Math.sqrt(S); var a = Math.max(25, Math.round(D * .9 / 5) * 5), b = Math.round(D * 1.05 / 5) * 5; if (b <= a) b = a + 5; return [a, b, D]; }

  function quiz(el) {
    if (!el || el.__pdq) return; el.__pdq = 1;
    var cfg = {};
    var cs = el.getAttribute('data-cfg') && $(el.getAttribute('data-cfg'));
    if (cs) { try { cfg = JSON.parse(cs.textContent); } catch (e) { cfg = {}; } }
    var T = {}; Object.keys(DEF.t).forEach(function (k) { T[k] = (cfg.t && cfg.t[k]) || DEF.t[k]; });
    var ROOMS = cfg.rooms ? lines(cfg.rooms) : DEF.rooms;
    var HEIGHTS = cfg.heights ? lines(cfg.heights) : DEF.heights;
    var STYLES = cfg.styles ? lines(cfg.styles) : DEF.styles;
    if (!ROOMS.length) ROOMS = DEF.rooms; if (!HEIGHTS.length) HEIGHTS = DEF.heights; if (!STYLES.length) STYLES = DEF.styles;
    var collUrl = cfg.collUrl || DEF.collUrl, allUrl = cfg.allUrl || DEF.allUrl;
    var PROG = String(T.prog).split(',').map(function (x) { return x.trim(); });
    var qid = el.getAttribute('data-quiz') || 'q';
    var s = { step: 0, room: null, surf: 18, h: null, style: null };
    function find(list, k) { return list.filter(function (x) { return x[0] === k; })[0]; }

    /* paramètres d'URL (liens de l'accueil) */
    if (el.hasAttribute('data-params') && window.URLSearchParams) {
      var q = new URLSearchParams(window.location.search);
      var pr = q.get('piece'), sf = parseInt(q.get('surface'), 10), ht = q.get('hauteur'), sy = q.get('style');
      if (pr && find(ROOMS, pr)) s.room = pr;
      if (!isNaN(sf)) s.surf = Math.max(6, Math.min(50, sf));
      if (ht && find(HEIGHTS, ht)) s.h = ht;
      if (sy && find(STYLES, sy)) s.style = sy;
      if (s.room || !isNaN(sf) || s.h || s.style) {
        s.step = !s.room ? 0 : (isNaN(sf) && !s.h && !s.style) ? 1 : !s.h ? 2 : !s.style ? 3 : 4;
      }
    }

    function prog() { return '<ol class="qprog" aria-label="Étapes">' + PROG.map(function (l, i) { return '<li class="' + (i <= s.step ? 'on' : '') + '"' + (i === s.step ? ' aria-current="step"' : '') + '>' + esc(l) + '</li>'; }).join('') + '</ol>'; }
    function nav(next) { return '<div class="qnav"><button type="button" class="qback" data-qback' + (s.step === 0 ? ' disabled' : '') + '>' + ico('i-arl') + 'Retour</button>' + (next ? '<button type="button" class="btn btn-p btn-s" data-qnext>Continuer' + ico('i-arr', 'arr') + '</button>' : '') + '</div>'; }
    function roomName() { var r = find(ROOMS, s.room); return (r && r[4]) || 'une pièce'; }
    function render(focus) {
      var h = prog();
      if (s.step === 0) h += '<div class="qstep"><h3>' + T.q1 + '</h3><p class="hint">' + esc(T.h1) + '</p><div class="qopts">' + ROOMS.map(function (r) { return '<button type="button" class="qo" data-qroom="' + esc(r[0]) + '" aria-pressed="' + (s.room === r[0]) + '">' + ico('i-' + (r[2] || 'sofa')) + esc(r[1]) + '</button>'; }).join('') + '</div>' + nav(false) + '</div>';
      if (s.step === 1) { var r = diamRange(s.surf); h += '<div class="qstep"><h3>' + T.q2 + '</h3><p class="hint">' + esc(T.h2) + '</p><div class="qsurf"><div class="big"><span data-qs>' + s.surf + '</span><small>m²</small></div><label class="sr" for="qr' + esc(qid) + '">Surface en mètres carrés</label><input type="range" id="qr' + esc(qid) + '" min="6" max="50" step="1" value="' + s.surf + '" data-qrange><div class="rec"><span class="plan" aria-hidden="true"><i style="width:' + Math.round(30 + s.surf) + 'px;height:' + Math.round(30 + s.surf) + 'px;--d:' + Math.round(r[2] / 4) + 'px" data-qplan></i></span><span>Diamètre conseillé : <b data-qd>' + r[0] + ' à ' + r[1] + ' cm</b></span></div></div>' + nav(true) + '</div>'; }
      if (s.step === 2) h += '<div class="qstep"><h3>' + T.q3 + '</h3><p class="hint">' + esc(T.h3) + '</p><div class="qopts row">' + HEIGHTS.map(function (x) { return '<button type="button" class="qo" data-qh="' + esc(x[0]) + '" aria-pressed="' + (s.h === x[0]) + '">' + ico('i-ruler') + '<span>' + esc(x[1]) + '<small>' + esc(x[2] || '') + '</small></span></button>'; }).join('') + '</div>' + nav(false) + '</div>';
      if (s.step === 3) h += '<div class="qstep"><h3>' + T.q4 + '</h3><p class="hint">' + esc(T.h4) + '</p><div class="qopts">' + STYLES.map(function (x) { return '<button type="button" class="qo" data-qst="' + esc(x[0]) + '" aria-pressed="' + (s.style === x[0]) + '">' + ico('i-swatch') + esc(x[1]) + '<small>' + esc(x[2] || '') + '</small></button>'; }).join('') + '</div>' + nav(false) + '</div>';
      if (s.step === 4) {
        el.innerHTML = h + '<div class="qstep qres" aria-busy="true"><p class="sum-l">…</p></div>';
        loadData().then(function (data) { if (s.step !== 4) return; el.innerHTML = prog() + result(data || []); after(focus); });
        return;
      }
      el.innerHTML = h; after(focus);
    }
    function after(focus) {
      nb(el);
      if (focus) { var t = $('.qstep h3, .qstep .sum-l', el); if (t) { t.setAttribute('tabindex', '-1'); t.focus({ preventScroll: true }); } }
    }
    function result(data) {
      var r = diamRange(s.surf), D = r[2];
      var hx = find(HEIGHTS, s.h) || [];
      var hTxt = (TABLE_ROOMS.indexOf(s.room) > -1 && hx[4]) ? hx[4] : (hx[3] || '');
      var cands = data.filter(function (p) { return p && p.sz && p.sz.length; }).map(function (p) {
        var best = p.sz.reduce(function (a, b) { return Math.abs(b.d - D) < Math.abs(a.d - D) ? b : a; });
        var sc = 0, tk = String(p.tk || '').toLowerCase();
        if ((p.pc || []).indexOf(s.room) > -1) sc += 3;
        if (s.style && s.style !== 'tous' && (p.st || []).indexOf(s.style) > -1) sc += 3;
        sc += 3 * (1 - Math.min(1, Math.abs(best.d - D) / D));
        if (best.s >= s.surf * .8) sc += 1;
        if (p.lin && TABLE_ROOMS.indexOf(s.room) > -1) sc += 1.5;
        if (s.h === 'bas') { if (tk === 'plafonnier') sc += 4; if (tk === 'lustre') sc -= 2; }
        if (s.h === 'tres' && tk === 'lustre') sc += 2;
        if (s.h === 'haut' && tk === 'lustre') sc += 1;
        return { p: p, b: best, sc: sc };
      }).sort(function (a, b) { return b.sc - a.sc; }).slice(0, 3);
      var room = find(ROOMS, s.room), coll = room && room[3] ? collUrl.replace(/\/$/, '') + '/' + encodeURIComponent(room[3]) : allUrl;
      var sum = '<p class="sum-l">Pour ' + esc(roomName()) + ' de <em>' + s.surf + ' m²</em> : un luminaire d\'environ <em>Ø ' + r[0] + ' à ' + r[1] + ' cm</em>' + (hTxt ? ', ' + esc(hTxt) : '') + '.</p>';
      var cards = cands.length ? '<div class="qcards">' + cands.map(function (c) {
        var fit = (c.p.sz.length > 1 || c.b.d) ? ('À votre taille : ' + c.b.c) : 'Taille unique';
        var img = c.p.img ? '<img src="' + esc(c.p.img) + '" alt="' + esc(c.p.alt || c.p.n) + '" loading="lazy" width="640" height="800">' : '';
        var sub = esc(c.p.t || '') + (c.p.m ? ' · ' + esc(c.p.m) : '') + (c.b.s ? '<br>Jusqu\'à ' + c.b.s + ' m²' : '');
        return '<a class="qc" href="' + esc(c.p.u) + '"><span class="fr' + (img ? ' solo' : ' slot') + '">' + (img || '<span class="in">' + '<svg viewBox="0 0 24 34" aria-hidden="true" focusable="false"><use href="#drop"/></svg></span>') + '<span class="fit">' + esc(fit) + '</span></span><h4>' + esc(c.p.n) + '</h4><p>' + sub + '</p><span class="pr">' + money(c.b.p) + '</span></a>';
      }).join('') + '</div>' : '<p class="muted">' + esc(T.empty) + '</p>';
      return '<div class="qstep qres">' + sum + cards + '<div class="qnav"><button type="button" class="qback" data-qback>' + ico('i-arl') + 'Modifier</button><div style="display:flex;gap:18px;flex-wrap:wrap;align-items:center"><button type="button" class="lnk" data-qreset>Recommencer</button><a class="btn btn-p btn-s" href="' + esc(coll) + '">' + esc(T.see) + '</a></div></div></div>';
    }
    function go1(b) { $$('.qo', el).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); }); setTimeout(function () { s.step++; render(true); }, RM ? 0 : 260); }
    el.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('[data-qroom]'))) { s.room = b.getAttribute('data-qroom'); go1(b); return; }
      if ((b = e.target.closest('[data-qh]'))) { s.h = b.getAttribute('data-qh'); go1(b); return; }
      if ((b = e.target.closest('[data-qst]'))) { s.style = b.getAttribute('data-qst'); go1(b); loadData(); return; }
      if (e.target.closest('[data-qnext]')) { s.step++; render(true); return; }
      if (e.target.closest('[data-qback]')) { s.step = Math.max(0, s.step - 1); render(true); return; }
      if (e.target.closest('[data-qreset]')) { s = { step: 0, room: null, surf: 18, h: null, style: null }; render(true); return; }
    });
    el.addEventListener('input', function (e) {
      if (!e.target.matches('[data-qrange]')) return;
      s.surf = +e.target.value; var r = diamRange(s.surf);
      $('[data-qs]', el).textContent = s.surf; $('[data-qd]', el).textContent = r[0] + ' à ' + r[1] + ' cm';
      var pl = $('[data-qplan]', el); pl.style.width = pl.style.height = Math.round(30 + s.surf) + 'px'; pl.style.setProperty('--d', Math.round(r[2] / 4) + 'px');
      nb($('.rec', el));
    });
    render(false);
  }
  PD.quiz = quiz;

  /* ------------------------------------------------------------ suivi de commande */
  function bindTrack(root) {
    $$('form[data-pd-track]', root).forEach(function (f) {
      if (f.__pd) return; f.__pd = 1;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var n = $('[data-tr-n]', f), m = $('[data-tr-m]', f), msg = $('[data-tr-msg]', f);
        var num = (n.value || '').trim(), mail = (m.value || '').trim();
        n.removeAttribute('aria-invalid'); m.removeAttribute('aria-invalid');
        if (!num) { msg.textContent = 'Indiquez votre numéro de commande.'; n.setAttribute('aria-invalid', 'true'); n.focus(); return; }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) { msg.textContent = 'Indiquez l\'adresse e-mail utilisée lors de l\'achat.'; m.setAttribute('aria-invalid', 'true'); m.focus(); return; }
        msg.textContent = '';
        var res = document.getElementById('trRes'), help = document.getElementById('trHelp');
        if (!res) { window.location.href = f.action; return; }
        var sp = $('[data-tr-num]', res); if (sp) sp.textContent = num;
        res.hidden = false; if (help) help.hidden = true;
        nb(res); res.focus({ preventScroll: true });
        if (window.innerWidth < 760) res.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ------------------------------------------------------------ 404 : la recherche ouvre le calque de recherche */
  function bind404(root) {
    $$('form[data-pd-404search]', root).forEach(function (f) {
      if (f.__pd) return; f.__pd = 1;
      f.addEventListener('submit', function (e) {
        var ov = document.getElementById('ovSearch'); if (!ov || !PD.openLayer) return;
        var inp = $('input[type=search]', ov); if (!inp) return;
        e.preventDefault();
        PD.openLayer('ovSearch');
        inp.value = $('input[name=q]', f).value;
        inp.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  }

  /* ------------------------------------------------------------ article : mise en forme de la maquette */
  function bindArticle(root) {
    $$('[data-pd-art]', root).forEach(function (body) {
      if (body.__pd) return; body.__pd = 1;
      var first = body.firstElementChild; if (first && first.tagName === 'P') first.classList.add('leadp');
      $$('h2', body).forEach(function (h, i) { if (!h.id) h.id = 'ar' + (i + 1); });
      /* citation commençant par un petit texte → encadré « À retenir » (.rule) ; sinon citation (.pull) */
      $$('blockquote', body).forEach(function (bq) {
        var sm = $('small', bq);
        if (sm) {
          var box = document.createElement('div'); box.className = 'rule';
          var st = $('strong, b', bq);
          var html = bq.innerHTML;
          var rest = html.replace(sm.outerHTML, '').replace(st ? st.outerHTML : '', '').replace(/<\/?p[^>]*>/g, '').replace(/^(\s|<br\s*\/?>)+|(\s|<br\s*\/?>)+$/g, '');
          box.innerHTML = '<small>' + sm.innerHTML + '</small>' + (st ? '<b>' + st.innerHTML + '</b>' : '') + (rest ? '<span>' + rest + '</span>' : '');
          bq.parentNode.replaceChild(box, bq);
        } else {
          var p = document.createElement('p'); p.className = 'pull'; p.innerHTML = bq.textContent.trim();
          bq.parentNode.replaceChild(p, bq);
        }
      });
      $$('table', body).forEach(function (t) {
        t.classList.add('tbl');
        if (!t.parentNode.classList.contains('tblw')) { var w = document.createElement('div'); w.className = 'tblw'; t.parentNode.insertBefore(w, t); w.appendChild(t); }
      });
      $$('a', body).forEach(function (a) { if (!a.className) a.classList.add('ulink'); });
      /* « Les modèles cités » : la liste de liens produits devient une grille de cartes */
      var tpl = document.querySelector('template[data-pd-inprod]');
      if (tpl && tpl.content && tpl.content.children.length) {
        var target = $$('ul, ol', body).filter(function (l) {
          var lis = $$('li', l); return lis.length && lis.every(function (li) { return $('a[href*="/products/"]', li); });
        })[0];
        if (target) {
          var g = document.createElement('div'); g.className = 'inprod'; g.appendChild(tpl.content.cloneNode(true));
          target.parentNode.replaceChild(g, target);
        }
      }
      nb(body);
    });
  }

  /* ------------------------------------------------------------ page panier : mise à jour sans rechargement */
  var cartSeq = 0;
  function cartPage() { return document.querySelector('[data-pd-cartpage]'); }
  function reloadCartPage() {
    var el = cartPage(); if (!el) return Promise.resolve();
    var my = ++cartSeq, sid = el.getAttribute('data-section');
    var url = (PD.routes && PD.routes.cart) || (ROOT + 'cart');
    return fetch(url + '?section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (my !== cartSeq) return;
        var d = document.createElement('div'); d.innerHTML = html;
        var nx = $('[data-pd-cartpage]', d); if (!nx) return;
        var cur = cartPage(); if (!cur) return;
        var focusSel = document.activeElement && document.activeElement.closest && cur.contains(document.activeElement) ? document.activeElement.getAttribute('data-cq') : null;
        cur.innerHTML = nx.innerHTML;
        if (PD.fillEta) PD.fillEta(cur); nb(cur);
        if (focusSel) { var f = $('[data-cq="' + focusSel + '"]', cur); if (f) f.focus(); }
      }).catch(function () {});
  }
  document.addEventListener('pd:cart', function () { if (cartPage()) reloadCartPage(); });
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Une erreur est survenue, merci de réessayer.'); return j; }); });
  }
  function codeMsg(t) { var m = $('[data-pg-code-msg]'); if (m) m.textContent = t || ''; }
  function applyCode(code) {
    var R = PD.routes || {};
    return postJSON(R.cartUpdate || ROOT + 'cart/update.js', { discount: code })
      .then(function () { return PD.refreshCart ? PD.refreshCart(false) : fetch(R.cartJson || ROOT + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (c) {
        var dc = ((c && c.discount_codes) || []).filter(function (x) { return String(x.code).toLowerCase() === code.toLowerCase(); })[0];
        return reloadCartPage().then(function () {
          codeMsg(dc && dc.applicable === false ? 'Ce code ne s’applique pas à votre sélection.' : (dc ? 'Code « ' + code + ' » appliqué.' : 'Ce code n’est pas valable.'));
        });
      }).catch(function () { codeMsg('Ce code n’est pas valable.'); });
  }
  document.addEventListener('click', function (e) {
    var el;
    if ((el = e.target.closest('[data-pg-code-apply]'))) {
      e.preventDefault(); var inp = $('[data-pg-code]'); var code = inp && inp.value.trim();
      if (!code) { codeMsg('Saisissez votre code.'); if (inp) inp.focus(); return; }
      el.classList.add('is-loading'); applyCode(code); return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-pg-code]')) { e.preventDefault(); var b = $('[data-pg-code-apply]'); if (b) b.click(); }
  });

  /* ------------------------------------------------------------ démarrage */
  function init(root) {
    root = root || document;
    $$('[data-quiz]', root).forEach(function (el) {
      /* un outil déjà rempli par un autre script n'est pas repris */
      if (!el.__pdq && !el.querySelector('.qstep, .qprog')) quiz(el);
    });
    bindTrack(root); bind404(root); bindArticle(root);
    var f = $('[data-pd-focus]', root); if (f && root === document) { try { f.focus(); } catch (e) {} }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
